module.exports = __webpack_public_path__ + "img/background-change-password.de67b0e6.jpg";